import $ from "jquery";
import app, { u_, vuwer } from "@@assets/scripts/common";

// [articleSection] VuwFade
vuwer
.add("articleSection", {
	vuwType: "fade",
	selector: "#article_section",
	
	onChangeState(state) {
		if(u_.isString(state.itemId) && state.itemId !== this.state.itemId ) {
			const dataArticle = this.get("dataArticle");
			const item = dataArticle.module.items.byId[state.itemId];
			return Promise.all([
				dataArticle.initList([item]),
				this.get("btnShowList").setState({ ...app._GET })
			]);
		}
	}
}, function() {
	// [add child Vuw]
	this
	// define [dataArticle]
	.add("dataArticle", {
		vuwType: "colony",
		selector: "#data_article",
		
		// ** for TyrellModule **
		module: app.news,
		
		// ** for VuwColony **
		autoLoad: false,
		// 記事のテンプレートのセレクタ（未指定の場合は最後の子要素がテンプレートとなる）
		articleTemplate: "",
		// ページャーの表示・非表示
		showPager: false,
		
		// 記事表示用の関数（未指定の場合はテンプレートから生成）
		initArticle(item, config, $article, module) {
			$article.find(".ql-video").each((i, elm) => {
				$(elm).wrap( $("<div/>").addClass("video-container") );
			})
		},
		
		async onReady($self) {
			if(!$self) {
				return false;
			}
			
			const { response } = await this.module.vuw._loadPromise;
			if(response.template) {
				this.setArticleTemplate(response.template);
			}
			
			if(app._GET.post) {
				const { getFilter } = this.module;
				Array.isArray(getFilter.conditions) || (getFilter.conditions = []);
				getFilter.conditions.push({
					"targetParam": "itemId",
					"condition": "eq",
					"value": app._GET.post
				});
				
				await this.module.loadItems();
				getFilter.conditions.pop();
			}
		}
	})
	
	// [btnShowList]
	.add("btnShowList", {
		selector: "#btn_show_list",
		onChangeState(state) {
			u_.hasProperty(state, "post") && (delete state.post);
			this.$self.attr("href", `./${u_.createQueryString(state)}`);
		}
	});
});
